<ng-container *ngIf="result">
  <div class="col-12 px-2 pl-md-3 position-static"
       data-cy="mb-search-family-line-name"
       [ngClass]="[result?.hasText ? 'mt-1' : 'mt-0']"
  >
    <div class="cursor-pointer pb-3 pb-md-0">
      <mb-link [dataEventAction]="result.isPDF ? result.contentType || 'PDF' : ''"
               [dataEventLabel]="title"
               [linkData]="{ url: result.seoURL, target: '_self', tooltip: title,
                             uid: result.seoURL?.includes('http') || result.seoURL?.includes('http') ? 'url' : 'content_link' }"
               [useSlot]="true"
               dataTarget="_self"
               styleClass="result-item"
      >
        <strong [innerHTML]="result.title"></strong>
        <span *ngIf="result.contentType?.length"
              class="content-type"
              [innerHTML]="result.contentType | safeHtml"
        ></span>
      </mb-link>
    </div>
    <p class="content-excerpt"
       *ngIf="additionalInfo === 'description' && result.description?.length"
       [innerHTML]="result.description | safeHtml"
    ></p>
    <ul class="keywords"
        data-label="keywords"
        *ngIf="additionalInfo === 'keywords' && result.keywords?.length"
    >
      <li class="keyword">Keywords</li>
      <li class="keyword"
          *ngFor="let keyword of result.keywords"
          [innerHTML]="keyword ?? '' | safeHtml"
      ></li>
    </ul>
  </div>
</ng-container>
